export const DataPayPalCurrencies = [
  { value: "AUD", label: "Australian dollar - AUD" },
  { value: "BRL", label: "Brazilian real  - BRL" },
  { value: "CAD", label: "Canadian dollar - CAD" },
  { value: "CZK", label: "Czech koruna - CZK" },
  { value: "DKK", label: "Danish krone - DKK" },
  { value: "EUR", label: "Euro - EUR" },
  { value: "HDK", label: "Hong Kong dollar - HDK" },
  { value: "HUF", label: "Hungarian forint - HUF" },
  { value: "ILS", label: "Israeli new shekel - ILS" },
  { value: "JYP", label: "Japanese yen - JYP" },
  { value: "MYR", label: "Malaysian ringgit - MYR" },
  { value: "MXN", label: "Mexican peso - MXN" },
  { value: "TWD", label: "New Taiwan dollar - TWD" },
  { value: "NZD", label: "New Zealand dollar - NZD" },
  { value: "NOK", label: "Norwegian krone - NOK" },
  { value: "PHP", label: "Philippine peso - PHP" },
  { value: "PLN", label: "Polish złoty - PLN" },
  { value: "GBP", label: "Pound sterling - GBP" },
  { value: "RUB", label: "Russian ruble - RUB" },
  { value: "SGD", label: "Singapore dollar - SGD" },
  { value: "SEK", label: "Swedish krona - SEK" },
  { value: "CHF", label: "Swiss franc - CHF" },
  { value: "THB", label: "Thai baht - THB" },
  { value: "USD", label: "United States dollar - USD" },
];
